import { connectedAccountsStore } from '../store/store';
import { getSelectedAccount } from './getSelectedAccount';
export function getEditAccountSyncRequest() {
    var syncRequest = getSelectedAccount().syncRequest;
    var store = connectedAccountsStore();
    if (store.editAccountState.isOAuthSync) {
        return {
            Id: syncRequest.Id,
            DisplayName: store.editAccountState.displayName,
            IncomingServer: store.editAccountState.incomingServer,
            IncomingPort: parseInt(store.editAccountState.incomingPort),
            SmtpServerName: store.editAccountState.outgoingServer,
            SmtpServerPort: parseInt(store.editAccountState.outgoingPort),
        };
    }
    else {
        return {
            Id: syncRequest.Id,
            DisplayName: store.editAccountState.displayName,
            IncomingServer: store.editAccountState.incomingServer,
            IncomingPort: parseInt(store.editAccountState.incomingPort),
            SmtpServerName: store.editAccountState.outgoingServer,
            SmtpServerPort: parseInt(store.editAccountState.outgoingPort),
            IncomingUserName: store.editAccountState.username || undefined,
            IncomingPassword: store.editAccountState.password,
            IncomingAuth: store.editAccountState.incomingAuth,
            IncomingSecurity: store.editAccountState.incomingSecurity,
            SmtpUserName: store.editAccountState.altUsername || undefined,
            SmtpPassword: store.editAccountState.altPassword || undefined,
        };
    }
}
//# sourceMappingURL=getEditAccountSyncRequest.js.map